import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IClientNumber } from "src/app/models/client/client-number";
import { ICoverPage } from "src/app/models/cover-page/cover-page";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-create-cover-page-modal",
  templateUrl: "./create-cover-page-modal.component.html",
})
export class CreateCoverPageModalComponent {
  @Input() clientNumbers: IClientNumber[] = [];

  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<ICoverPage>();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.CreateCoverPage;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit(coverPage: ICoverPage) {
    this._modalService.closeModal();
    this.submit.emit(coverPage);
  }
}
